import _ from "lodash";
import accountManagement from "./accountManagement";
import baseSyntheticalManagement from "./baseSyntheticalManagement";
import baseManagement from "./baseManagement";
import commodityManagement from "./commodityManagement";
import operationManagement from "./operationManagement";
import statisticalAnalysis from "./statisticalAnalysis";
import supplyCentreSyntheticalManagement from "./supplyCentreSyntheticalManagement";
import supplyCentreManagement from "./supplyCentreManagement";
import tradeManagement from "./tradeManagement";
import statisticsManagement from "./statisticsManagement";
import mallManagement from "./mallManagement";
import paymentManagement from "./paymentManagement";
import partyMemberManagement from "./partyMemberManagement";
import ensureUserManagement from "./ensureUserManagement";
import healthManagement from "./healthManagement";
import feedbackManagement from "./feedbackManagement";
import opcManagement from "./opcManagement";
import reunionDinnerManagement from "./reunionDinnerManagement";
import accountCheckingManagement from "./accountCheckingManagement";
import legalManagement from "./legalManagement";

export default _.union(
  accountManagement,
  baseSyntheticalManagement,
  baseManagement,
  commodityManagement,
  operationManagement,
  statisticalAnalysis,
  supplyCentreSyntheticalManagement,
  supplyCentreManagement,
  tradeManagement,
  statisticsManagement,
  mallManagement,
  paymentManagement,
  partyMemberManagement,
  ensureUserManagement,
  healthManagement,
  feedbackManagement,
  opcManagement,
  reunionDinnerManagement,
  accountCheckingManagement,
  legalManagement,
  [
    {
      name: "supplySystem",
      path: "/supplySystem/:supplyId",
      meta: { title: "供应管理" },
      component: require("views/common/blank.vue").default
    }
    // {
    // name : 'workbench',
    // path : '/supplySystem/:supplyId/workbench',
    // meta : { title : '工作台' },
    // component : require('business/supplySystem/workbench.vue').default
    // },
    // {
    // 	name : 'userManagement',
    // 	path : '/supplySystem/:supplyId/userManagement',
    // 	meta : { title : '用户管理' },
    // 	component : require('business/supplySystem/userManagement/list.vue').default
    // }
  ]
);
